module.exports = __webpack_public_path__ + "img/gfx-c.2e6afa61.png";